import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeEsCo from '@angular/common/locales/es-CO';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from '@environments/environment';

registerLocaleData(localeEsCo);

bootstrapApplication(App, appConfig)
  .then(() => {
    if (!environment.production && 'serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => registration.unregister());
      });
    }
  })
  .catch((err) => console.error(err));
